import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route,useLocation  } from "react-router-dom";
import LoginPage from "./Pages/LoginPage";
import UserDashboard from "./Pages/UserDashboard";
import CustomerInfo from "./Pages/CustomerInfo";
import CustomerInvoices from "./Pages/CustomerInvoices";
import InvoiceDetails from "./Pages/InvoiceDetails";
import OpenOrderDetails from "./Pages/OpenOrderDetails";
import ProtectedRoute from "./components/ProtectedRoute";
import FinancialPage from "./Pages/FinancialPage";
import ReceivableNotesList from "./Pages/ReceivableNotesList";
import UnsettledInvoiceList from "./Pages/UnsettledInvoiceList";
import NotAnalysisReceiptInfo from "./Pages/NotAnalysisReceiptInfo";
import ReturnInvoicInfo from "./Pages/ReturnInvoiceInfo";
import ReturnInvoiceItems from "./Pages/ReturnInvoiceItems";
import ForgotPasswordPage from "./Pages/forgetPassword";
import ComplaintsList from "./Pages/Complaints";
import ProductCatalog from "./Pages/Catalogs";
import ComplaintsRequest from "./Pages/ComplaintsRequest";
import GuidePage from "./Pages/GuidePage";
import ComplaintsDetails from "./Pages/ComplaintDetails";
import PaymentResult from "./Pages/PaymentResult";
import PaymentHistory from "./Pages/PaymentHistory";
import { CustomerProvider } from "./context/customerContext";
import Footer from "./Pages/Footer";
import ContactUs from "./Pages/ContactUs";
import SalesReport from "./Pages/SalesReport";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// function App() {
//   useEffect(() => {
//     const preventGesture = (e) => {
//       e.preventDefault();
//     };

//     document.addEventListener("gesturestart", preventGesture);
//     document.addEventListener("gesturechange", preventGesture);
//     document.addEventListener("gestureend", preventGesture);

//     return () => {
//       document.removeEventListener("gesturestart", preventGesture);
//       document.removeEventListener("gesturechange", preventGesture);
//       document.removeEventListener("gestureend", preventGesture);
//     };
//   }, []);

//   return (
//     <Router>
//       <CustomerProvider>
//       {/* <div className="flex flex-col min-h-screen bg-gradient-to-b from-blue-100 to-white"> */}
//           <ToastContainer rtl position="top-center" autoClose={3000} />
//           <Routes>
//             {/* مسیر لاگین */}
//             {["/", "/login"].map((path) => (
//               <Route key={path} path={path} element={<LoginPage />} />
//             ))}

//             <Route path="/forgot-password" element={<ForgotPasswordPage />} />

//             {/* مسیرهای محافظت‌شده */}
//             <Route
//               path="/dashboard"
//               element={
//                 <ProtectedRoute>
//                   <UserDashboard />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="/customer-info"
//               element={
//                 <ProtectedRoute>
//                   <CustomerInfo />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="/customer-invoices"
//               element={
//                 <ProtectedRoute>
//                   <CustomerInvoices />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="/invoice-details/:id"
//               element={
//                 <ProtectedRoute>
//                   <InvoiceDetails />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="/financial-info"
//               element={
//                 <ProtectedRoute>
//                   <FinancialPage />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="/receivableNoteList"
//               element={
//                 <ProtectedRoute>
//                   <ReceivableNotesList />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="/unSettledInvoiceList"
//               element={
//                 <ProtectedRoute>
//                   <UnsettledInvoiceList />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="/returnInvoice-info"
//               element={
//                 <ProtectedRoute>
//                   <ReturnInvoicInfo />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="/returnInvoiceItems-details/:id"
//               element={
//                 <ProtectedRoute>
//                   <ReturnInvoiceItems />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="/product-image"
//               element={
//                 <ProtectedRoute>
//                   <ProductCatalog />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="/complaints-list"
//               element={
//                 <ProtectedRoute>
//                   <ComplaintsList />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="/complaints-request"
//               element={
//                 <ProtectedRoute>
//                   <ComplaintsRequest />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="/complaints-details/:requestNo"
//               element={
//                 <ProtectedRoute>
//                   <ComplaintsDetails />
//                 </ProtectedRoute>
//               }
//             />
//             <Route
//               path="/sales-report"
//               element={
//                 <ProtectedRoute>
//                   <SalesReport />
//                 </ProtectedRoute>
//               }
//             />

//             <Route
//               path="/contact-us"
//               element={
//                 <ProtectedRoute>
//                   <ContactUs />
//                 </ProtectedRoute>
//               }
//             />
//           </Routes>
//           <Footer />
//         {/* </div> */}
//       </CustomerProvider>
//     </Router>
//   );
// }
function AppContent() {
  const location = useLocation();

  // ✅ فقط در صفحه‌ی داشبورد فوتر نمایش داده شود
  const showFooter = location.pathname === "/dashboard";

  return (
    <>
      <ToastContainer rtl position="top-center" autoClose={3000} />
      <Routes>
        {/* مسیر لاگین */}
        {["/", "/login"].map((path) => (
          <Route key={path} path={path} element={<LoginPage />} />
        ))}

        <Route path="/forgot-password" element={<ForgotPasswordPage />} />

        {/* مسیرهای محافظت‌شده */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <UserDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customer-info"
          element={
            <ProtectedRoute>
              <CustomerInfo />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customer-invoices"
          element={
            <ProtectedRoute>
              <CustomerInvoices />
            </ProtectedRoute>
          }
        />
        <Route
          path="/invoice-details/:id"
          element={
            <ProtectedRoute>
              <InvoiceDetails />
            </ProtectedRoute>
          }
        />
          <Route
          path="/openOrder-details/:id"
          element={
            <ProtectedRoute>
              <OpenOrderDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/financial-info"
          element={
            <ProtectedRoute>
              <FinancialPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/receivableNoteList"
          element={
            <ProtectedRoute>
              <ReceivableNotesList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/unSettledInvoiceList"
          element={
            <ProtectedRoute>
              <UnsettledInvoiceList />
            </ProtectedRoute>
          }
        />
         <Route
          path="/notAnalysisReceiptInfo"
          element={
            <ProtectedRoute>
              <NotAnalysisReceiptInfo />
            </ProtectedRoute>
          }
        />
         <Route
          path="/payment-result"
          element={
            <ProtectedRoute>
              <PaymentResult />
            </ProtectedRoute>
          }
        />
        <Route
          path="/returnInvoice-info"
          element={
            <ProtectedRoute>
              <ReturnInvoicInfo />
            </ProtectedRoute>
          }
        />
        <Route
          path="/returnInvoiceItems-details/:id"
          element={
            <ProtectedRoute>
              <ReturnInvoiceItems />
            </ProtectedRoute>
          }
        />
        <Route
          path="/product-image"
          element={
            <ProtectedRoute>
              <ProductCatalog />
            </ProtectedRoute>
          }
        />
         <Route
          path="/payment-history"
          element={
            <ProtectedRoute>
              <PaymentHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/complaints-list"
          element={
            <ProtectedRoute>
              <ComplaintsList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/complaints-request"
          element={
            <ProtectedRoute>
              <ComplaintsRequest />
            </ProtectedRoute>
          }
        />
        <Route
          path="/guidepage"
          element={
            <ProtectedRoute>
              <GuidePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/complaints-details/:requestNo"
          element={
            <ProtectedRoute>
              <ComplaintsDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales-report"
          element={
            <ProtectedRoute>
              <SalesReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/contact-us"
          element={
            <ProtectedRoute>
              <ContactUs />
            </ProtectedRoute>
          }
        />
      </Routes>

      {/* ✅ فقط در صفحه داشبورد */}
      {/* {showFooter && <Footer />} */}
    </>
  );
}

function App() {
  useEffect(() => {
    const preventGesture = (e) => e.preventDefault();
    document.addEventListener("gesturestart", preventGesture);
    document.addEventListener("gesturechange", preventGesture);
    document.addEventListener("gestureend", preventGesture);
    return () => {
      document.removeEventListener("gesturestart", preventGesture);
      document.removeEventListener("gesturechange", preventGesture);
      document.removeEventListener("gestureend", preventGesture);
    };
  }, []);

  return (
    <Router>
      <CustomerProvider>
        <AppContent />
      </CustomerProvider>
    </Router>
  );
}

export default App;
